import { render, staticRenderFns } from "./EditContractSidebar.vue?vue&type=template&id=524b69b9"
import script from "./EditContractSidebar.vue?vue&type=script&lang=js"
export * from "./EditContractSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports